



































import {Component, Vue} from 'vue-property-decorator';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import EventCard from '../../../components/Events/EventCard.vue';
import {dispatchGetEvent} from '@/store/events/actions';
import {readEvent} from '@/store/events/getters';
import videojs from 'video.js';
import { LazyYoutube } from 'vue-lazytube';

@Component({
  components: {
      EventCard,
      PageSeparator,
      LazyYoutube,
  },
})
export default class EventView extends Vue {

  public options = {
    muted: false,
    language: 'en',
    poster: '',
    autoplay: true,
    controls: true,
    // playbackRates: [0.7, 1.0, 1.5, 2.0],
    sources: [{
      type: 'video/mp4',
      src: '',
    }],
  };
  public player = null;

  public async created() {
    await dispatchGetEvent(this.$store, {pk: this.$router.currentRoute.params.id});
    const event = readEvent(this.$store);
    if (!event) {
      this.$router.push('/events');
      return;
    }
    if (event && event.webinar && event.webinar.type === 'auto') {
      if (event.webinar.element) {
        this.options.sources = [
          {
            type: 'video/mp4',
            src: event.webinar.element.video_mp4 ? event.webinar.element.video_mp4 : '',
          },
          {
            type: 'video/webm',
            src: event.webinar.element.video_webm ? event.webinar.element.video_webm : '',
          },
          {
            type: 'video/ogg',
            src: event.webinar.element.video_ogv ? event.webinar.element.video_ogv : '',
          },
        ];
        this.options.poster = event.webinar.element.video_poster ? event.webinar.element.video_poster : '';
        this.player = videojs(this.$refs.videoPlayer, this.options);
      }
    }
  }
  get event() {
    return readEvent(this.$store);
  }
  public beforeDestroy() {
    if (this.player !== null) {
      // @ts-ignore
      this.player.dispose();
    }
  }

}
